import { Routes } from '@angular/router';
import { provideSelfServiceDomain } from '@zero/self-service/domain';

export const KWK_WEB_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/kwk-page/kwk-page.component').then((c) => c.KwkPageComponent),
    providers: [provideSelfServiceDomain()],
  },
];
